<div>
  <gstar-error-page
    [title]="'not-found-page.title' | translate"
    [description]="'not-found-page.description' | translate"
    image="assets/images/not-found/error-404.svg" />
</div>
